import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { TicketsQueryParams, TicketsResponseData } from '@/types';

import { HttpClient } from '@/network/HttpClient';

export const TICKETS_QUERY_KEY = 'tickets';

export const useTicketsQuery = (props: TicketsQueryParams) => {
  return useQuery({
    queryKey: [TICKETS_QUERY_KEY, props.fetchUrl, props.queryParams],
    queryFn: () =>
      HttpClient.request<TicketsResponseData>({
        method: 'GET',
        url: props.fetchUrl,
        params: props.queryParams,
      }),
    placeholderData: keepPreviousData,
  });
};
